module.exports = __webpack_public_path__ + "static/green-blue-gredient-bg-8511309c9cddbc210ed15272b5b5459c.png";